import React, { useEffect, useState } from 'react';
import Card from '../ui/Card';
import Button from '../ui/Button';
import { RefreshCw } from 'lucide-react';

const BackfillMonitor = () => {
  const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchStatus = async () => {
    try {
      setLoading(true);
      const adminToken = localStorage.getItem('admin_token');
      const resp = await fetch(`${API_BASE_URL}/api/admin/reports/job-files/backfill-status`, { headers: { 'Authorization': `Bearer ${adminToken}` } });
      const json = await resp.json();
      setData(json);
    } catch (e) {
      console.error('backfill-status error', e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(()=>{ fetchStatus(); },[]);

  return (
    <Card>
      <Card.Header>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <Card.Title>Job Files Backfill Monitor</Card.Title>
          <Button variant="secondary" onClick={fetchStatus} icon={<RefreshCw size={14} />}>Refresh</Button>
        </div>
      </Card.Header>
      <Card.Content>
        {loading ? (
          <div style={{ padding: 16, color:'#6b7280' }}>Loading...</div>
        ) : !data ? (
          <div style={{ padding: 16, color:'#6b7280' }}>No data</div>
        ) : (
          <div style={{ display:'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <div style={{ padding: 12, border:'1px solid #e5e7eb', borderRadius: 8 }}>
              <div style={{ fontSize:12, color:'#6b7280', marginBottom:8 }}>Window since: {new Date(data.since).toLocaleString()}</div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap: 8, fontSize:14 }}>
                <div>Total candidates</div><div style={{ fontWeight:600 }}>{data.total_candidates}</div>
                <div>Ready</div><div style={{ fontWeight:600, color:'#166534' }}>{data.ready}</div>
                <div>Pending</div><div style={{ fontWeight:600, color:'#92400e' }}>{data.pending}</div>
                <div>In Progress</div><div style={{ fontWeight:600, color:'#1e40af' }}>{data.in_progress}</div>
              </div>
            </div>
            <div style={{ padding: 12, border:'1px solid #e5e7eb', borderRadius: 8 }}>
              <div style={{ fontSize:12, color:'#6b7280', marginBottom:8 }}>Recent Ready</div>
              {(!data.recent_ready || data.recent_ready.length===0) ? (
                <div style={{ fontSize:12, color:'#6b7280' }}>No recent ready files</div>
              ) : (
                <ul style={{ margin:0, paddingLeft: 16 }}>
                  {data.recent_ready.map(r => (
                    <li key={r.job_id} style={{ fontSize:12 }}>
                      {(r.job_id||'').slice(0,8)}... • {r.user_email} • {r.s3_ready_at && new Date(r.s3_ready_at).toLocaleString()}
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <div style={{ gridColumn: '1 / span 2', padding: 12, border:'1px solid #e5e7eb', borderRadius: 8 }}>
              <div style={{ fontSize:12, color:'#6b7280', marginBottom:8 }}>Oldest Pending (first few)</div>
              {(!data.recent_pending || data.recent_pending.length===0) ? (
                <div style={{ fontSize:12, color:'#6b7280' }}>No pending</div>
              ) : (
                <ul style={{ margin:0, paddingLeft: 16, columns: 2 }}>
                  {data.recent_pending.map(r => (
                    <li key={r.job_id} style={{ fontSize:12, breakInside: 'avoid' }}>
                      {(r.job_id||'').slice(0,8)}... • {r.user_email} • {r.created_at && new Date(r.created_at).toLocaleString()} {r.in_progress ? '• in-progress' : ''}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        )}
      </Card.Content>
    </Card>
  );
};

export default BackfillMonitor;